import html2canvas from 'html2canvas';

jQuery(function ($) {
  console.log("HTML Publication ready");

  // Hardcoded clean up and content manipulation
  $('.btn.phr-back-to-publication span').text('Back to publication page');
  
  $('.btn.phr-print-button').remove();
  
  $('.phr-extras--buttons').append($('<a class="btn btn-s--pill btn-c--hollow phr-extras--button phr-back-button phr-back-to-top" href="#top"><img class="mr-3" src="/themes/custom/tema/src/assets/icons/icon-chevron-left-dark-blue.svg" alt="Back" style="transform: rotate(90deg)"><span>Back to top</span></a>'));

  if ($('.phr-extras--social').length > 0) {
    var clonedElement = $('.phr-extras--social').clone();

    // Append the cloned element into .phr-pub-title
    $('.phr-pub-title').append(clonedElement);
  }
  
  // Hardcoded clean up //////////////////////////////// END
  
  
  
  

  const tocHeadingLevel = 'h' + $('#phr-node-data').data('max-heading-level');
  const pubUrl = $('#phr-node-data').data('pub-url');
  const imagesUrl = $('#phr-node-data').data('images-url');

  // console.log('pubUrl', pubUrl);

  if (pubUrl === "") {
    $('.phr-back-to-publication').remove();
  } else {
    $('.phr-back-to-publication').attr('href', pubUrl);

    let backElm = $('<div class="mb-8 lg:hidden"><a class="back-to-overview phr-back-to-publication" href="">Back to publication</a></div>');

    backElm.attr('href', pubUrl);

    $('.phr-body').prepend(backElm);
  }

  if (imagesUrl === '') {
    $('.phr-downloadfile-button').parent().remove();
  } else {
    $('.phr-downloadfile-button').attr('href', imagesUrl);
  }

  $('.phr-source--collapse---toggle').on('click', function () {
    const elm = $(this);

    if (elm.hasClass('active')) {
      elm.removeClass('active');
      elm.next().hide();
    } else {
      elm.addClass('active');
      elm.next().show();
    }
  });

  const tocMenu = $('#phr-toc-menu');

  // Creating TOC
  if ($('.phr-toc-scan').length > 0) {
    let chapterId = 0; // Unique id for each chapter
    let chapterElm = $(''); // keep track of last toc chapter item
    let chapterChildrenCount = 0;

    $('.phr-toc-scan').each(function (idx) {
      const elm = $(this);
      elm.attr('data-idx', idx);

      // Check if its chapter bar
      if (elm.hasClass('phr-chapter-bar')) {
        if (chapterChildrenCount > 0) { // This mean previous chapter has children, we need to append collapse toggle to it
          // Add collapsed class if collapsed by default
          chapterElm.append('<span data-idx="' + chapterId + '" class=""></span>');
          chapterChildrenCount = 0; // Reset count for next chapter's children
        }

        chapterId++; // Increase chapter index

        const subtitle = elm.find('.phr-chapter-subtitle').text();
        const title = elm.find('.phr-chapter-title').text();

        if (subtitle !== '' || title !== '') {
          elm.attr('id', 'toc' + idx);

          let html = '<a href="' + '#toc' + idx + '" class="phr-toc--item phr-toc--item---chapter" data-level>';

          if (subtitle !== '') {
            html += '<div class="phr-toc--item---subtitle font-bold">' + subtitle + '</div>';
          }

          if (title !== '') {
            html += '<div class="phr-toc--item---title font-bold">' + title + '</div>';
          }

          html += '</a>';

          chapterElm = $(html);

          tocMenu.append(chapterElm);
        }
      }

      if (elm.hasClass('h2') || elm.hasClass('h3') || elm.hasClass('h4') || elm.hasClass('h5')) {
        elm.attr('id', 'toc' + idx);
        const text = elm.text();
        let cssClass = '';
        let hideByDefault = false;

        if (!elm.hasClass('phr-toc-scan--special')) {
          chapterChildrenCount++;

          if (elm.hasClass('h2')) {
            if (tocHeadingLevel < 'h2') { return; } // if heading level is less than max level set in node
            cssClass = 'ml-4 phr-toc--level-2';
          }
          if (elm.hasClass('h3')) {
            if (tocHeadingLevel < 'h3') { return; } // if heading level is less than max level set in node
            cssClass = 'ml-8 phr-toc--level-3';
          }
          if (elm.hasClass('h4')) {
            if (tocHeadingLevel < 'h4') { return; } // if heading level is less than max level set in node
            cssClass = 'ml-12 phr-toc--level-4';
          }
          if (elm.hasClass('h5')) {
            if (tocHeadingLevel < 'h5') { return; } // if heading level is less than max level set in node
            cssClass = 'ml-16 phr-toc--level-5';
          }

          hideByDefault = false;
        }

        let tocElm = $('<a href="' + '#toc' + idx + '" class="phr-toc--item phr-toc--item---sub ' + cssClass + '">' + text + '</a>');

        if (!elm.hasClass('phr-toc-scan--special')) {
          tocElm.addClass('phr-toc--item---collapse-' + chapterId);
        } else {
          tocElm.addClass('!font-bold');
        }

        if (hideByDefault) {
          tocElm.css('display', 'none');
        }

        tocMenu.append(tocElm);
      }
    });

    $('a.phr-toc--item').on(
      "click",
      function () {
        let margin = 0;
        if ($(this).hasClass("anchor-link")) {
          margin = $(".anchor-navigation").outerHeight();
        }

        if (
          location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          var target = $(this.hash);
          target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
          if (target.length) {
            $("html,body").animate(
              {
                scrollTop: target.offset().top - margin,
              },
              1000
            );

            target.trigger("focus");
            return false;
          }
        }
      }
    );

    $('a.phr-toc--item---chapter span').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const elm = $(this);
      const idx = elm.data('idx');

      if (elm.hasClass('collapsed')) {
        elm.removeClass('collapsed');
        $('.phr-toc--item---collapse-' + idx).css('display', 'block');
      } else {
        elm.addClass('collapsed');
        $('.phr-toc--item---collapse-' + idx).css('display', 'none');
      }
    });
  }

  $('.phr-print-button').on('click', function () {
    window.print();
  });

  function isInViewport(element) {
    var elementTop = element.offset().top;
    var elementBottom = elementTop + element.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  function checkVisibility() {

    let visibleElement = null;

    $('.phr-toc-scan').each(function () {
      const elm = $(this);
      const idx = elm.data('idx');

      if (isInViewport(elm)) {
        $('.phr-toc--item[href="#toc' + idx + '"]').css('color', '#004587');
        $('.phr-toc--item[href="#toc' + idx + '"]').css('font-weight', 'bold');
        visibleElement = elm;
      } else {
        $('.phr-toc--item[href="#toc' + idx + '"]').css('color', 'unset');
        $('.phr-toc--item[href="#toc' + idx + '"]').css('font-weight', 'normal');
      }
    });

    $('.phr-chapter-wrapper').each(function (index) {
      const elm = $(this);
      const idx = elm.find('.phr-toc-scan.phr-chapter-bar').data('idx');

      if (isInViewport(elm) && idx >= 0) {
        $('.phr-toc--item[href="#toc' + idx + '"]').css('color', '#004587');
        $('.phr-toc--item[href="#toc' + idx + '"]').css('font-weight', 'bold');
      } else {
        $('.phr-toc--item[href="#toc' + idx + '"]').css('color', 'unset');
        $('.phr-toc--item[href="#toc' + idx + '"]').css('font-weight', 'normal');
      }
    });

    // If a visible element is found, update the vSelect display text
    if (visibleElement) {
      const idx = visibleElement.data('idx');
      let title = "";

      if (visibleElement.find('.phr-chapter-title').length > 0) {
        title = visibleElement.find('.phr-chapter-title').text();
      } else {
        title = visibleElement.text();
      }

      // Update the display text of the vSelect
      $('.vselect-display-text').text(title);

      // Update the select dropdown to reflect the visible section
      $('.phr-mobile-toc select').val('#toc' + idx).trigger('change');
    }
  }

  $(window).on('scroll', function () {
    checkVisibility();
  });

  setTimeout(() => {
    checkVisibility();
  }, 1000);

  // Creating mobile TOC select list
  let $select = $('<select></select>');

  let options = [];

  $('a.phr-toc--item').each(function (index) {
    const elm = $(this);
    const href = elm.attr('href');
    let label = '';

    if (elm.find('.phr-toc--item---title').length > 0) {
      label = elm.find('.phr-toc--item---title').text();
    } else {
      label = elm.text();
    }

    // console.log('option', href, label);
    options.push({
      value: href,
      text: label,
    });
  });

  options.forEach(function (option) {
    let $option = $("<option></option>")
      .attr("value", option.value)
      .text(option.text);
    $select.append($option);
  });

  // Step 3: Append the select element to the div with class "phr-mobile-toc"
  $(".phr-mobile-toc").append($select);

  $(".phr-mobile-toc select").vSelect({
    search: false,
    checkAll: false,
    multiSelect: false,
    onChange: function (values, options) {
      const href = values.value;

      $('html, body').animate({
        scrollTop: $(href).offset().top - 100
      }, 1000);

      setTimeout(() => {
        $('.vselect-display-text').text(values.label);
      }, 10);
    }
  });

  // Enable download of source download links
  $('.phr-block--sidebar a.phr-source--download').each(function () {
    const elm = $(this);

    let parent = elm.parent();

    // Looking for parent with phr-block--sidebar class
    while (parent !== undefined && !parent.hasClass('phr-block--sidebar')) {
      parent = parent.parent();
    }

    // If found
    if (parent !== undefined && parent.length > 0) {
      // Looking of img element inside div with phr-image class
      const img = parent.prev().find('.phr-image img');

      // If found
      if (img.length > 0) {
        const imgSrc = img.attr('src');

        // Replace the download figure link href attribute
        elm.attr('href', imgSrc);
        elm.attr('download', true);
      }

      const table = parent.prev().find('.phr-table table');

      if (table.length > 0) {
        elm.on('click', function (e) {
          e.preventDefault();

          console.log('Download table');

          html2canvas(table[0]).then(function (canvas) {
            // Create an a element for the download
            var link = document.createElement('a');
            // Set the href to the canvas data URL
            link.href = canvas.toDataURL('image/png');
            // Set the download attribute so the browser will download the file
            link.download = 'table.png';
            // Append the link to the body
            document.body.appendChild(link);
            // Trigger a click on the link to start the download
            link.click();
            // Remove the link from the document
            document.body.removeChild(link);
          });

          return false;
        });
      }
    }
  });

  //change mobile toc name
  $(document).ready(function () {
    $('.vselect-display-text').text('Chapter List');
  });


  //footnote
  $('.phr-note').each(function () {
    var supElement = $(this).find('sup');

    if (supElement.length > 0) {
      var supNumber = supElement.text();
      var hrefValue = '#footnote-list' + supNumber;
      var idValue = 'footnote' + supNumber;

      $(this).attr('href', hrefValue);
      $(this).attr('id', idValue);
    }
  });

  $('#footnote ol li').each(function (index) {
    var idValue = 'footnote-list' + (index + 1);
    var customHrefValue = '#footnote' + (index + 1);

    $(this).attr('id', idValue).attr('data-href', customHrefValue);
  });

  $('#footnote ol li').on('click', function () {
    const target = $(this).attr('data-href');
    const customOffset = 100;

    if ($(target).length) {
      $('html, body').animate({
        scrollTop: $(target).offset().top - customOffset
      }, 1000);
      $(target).focus();
    }
  });

  $('.phr-note').on('click', function (event) {
    event.preventDefault();

    const target = $(this).attr('href');
    const customOffset = 100;

    if ($(target).length) {
      $('html, body').animate({
        scrollTop: $(target).offset().top - customOffset
      }, 1000);
      $(target).focus();
    }
  });
  //footnote END


  // open all link in new tab
  $('.phr-block--content a:not(.phr-back-to-top)').each(function () {
    $(this).attr('target', '_blank');
  });


  // back to top button
  $('#back-to-top-htmlpub').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });


  // set block flex for image title up mobile
  $('.phr-block').each(function () {
    if ($(this).find('.phr-block--sidebar').length > 0) {
      $(this).addClass('flex flex-col-reverse');
    }
  });

  // hover on footnote, tooltip the content
  $(".phr-note").hover(
    function () {

      var currentId = $(this).attr("id");
      var tooltipText = $("#" + currentId.replace("footnote", "footnote-list")).text();
      var $tooltip = $("<div class='phr-note--tooltip'>" + tooltipText + "</div>");

      $(this).append($tooltip);
      $tooltip.fadeIn(200);
    },

    function () {
      $(this).find(".phr-note--tooltip").fadeOut(200, function () {
        $(this).remove();
      });
    }
  );
  // hover on footnote, tooltip the content END

  $(window).on("scroll", function () {

    // scroll to allow mobile-toc be sticky on top
    if ($(window).scrollTop() >= 1260) {
      $(".phr-mobile-toc").addClass("fixed top-0 phr-scroll-mobile-toc");
    } else {
      $(".phr-mobile-toc").removeClass("fixed top-0 phr-scroll-mobile-toc");
    }


    // show back on top
    if ($(window).scrollTop() >= 1260) {
      $("#back-to-top-htmlpub").removeClass("hidden");
    } else {
      $("#back-to-top-htmlpub").addClass("hidden");
    }

    // scroll progress bar
    if ($(window).scrollTop() >= 1260) {
      $(".html-progress-bar").removeClass("hidden");
    } else {
      $(".html-progress-bar").addClass("hidden");
    }

    progressBarScroll();
  });

  function progressBarScroll() {
    let winScroll = $(window).scrollTop(),
      height = $(document).height() - $(window).height(),
      scrolled = (winScroll / height) * 100;
    $("#progressBar").css("width", scrolled + "%");
  }












});
